module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAzMCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yLjEyMDEyIDExTDEwLjUyMDUgMTkuNDAwNUwyNy4zMjE0IDIuNTk5NjEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/educationalInstitutionAddRecruiter/assets/Vector.svg
// module id = DzWS
// module chunks = 1